import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FileUpload,
  AttachDocumentsDTO,
  AttachDocumentsFilesDTO,
  DocumentIdNumRequestDTO,
} from '../model/requests-model';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DocumentationUploadService } from './update-documentation.service';
import { CredentialsService } from '@app/login';
import { PanelStore } from '../panel/panel.store';
import { REQUEST_MODE_EDIT, REQUEST_MODE_VIEW, REQUEST_PENDING } from '@app/@core/constants/requests.constants';
import { UpdateDocumentationStore } from './update-documentation.store';
import { HOME } from '@app/@core/constants/routes.constants';

@Component({
  selector: 'app-documentation',
  templateUrl: './update-documentation.component.html',
  styleUrls: ['./update-documentation.component.scss'],
})
export class UpdateDocumentationComponent implements OnInit, OnDestroy {
  numOperation: string;
  selectedFiles: FileUpload[] = [null, null, null, null, null, null];
  errorDescription: string;
  errorFileRepeat: string;
  errorNotFile: string;
  filesToSendEnd: AttachDocumentsFilesDTO;
  disableBtnUpload: boolean = true;
  emptlyDescription: boolean = false;
  goBack: boolean = false;
  files: any[] = [];
  uploadMail: boolean = false;
  commercialProduct: string;

  documentIdNumRequestDTO: DocumentIdNumRequestDTO;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private dialog: MatDialog,
    public translate: TranslateService,
    private documentationUploadService: DocumentationUploadService,
    private credentialsService: CredentialsService,
    private panelStore: PanelStore,
    private updateDocumentationStore: UpdateDocumentationStore
  ) {
    if (this.router.getCurrentNavigation()) {
      this.commercialProduct = this.router.getCurrentNavigation().extras.state?.commercialProduct;
    }
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.numOperation = params['numOperation'];
      this.goBack = params['goBack'];
      if (this.numOperation) {
        this.documentIdNumRequestDTO = this.updateDocumentationStore.getDocumentIdNumRequestHistoryByNumRequest(
          this.numOperation
        );
      }
    });

    this.route.queryParams.subscribe((params) => {
      if (params['docUrl'] === 'true' || params['url'] === 'true') {
        this.uploadMail = true;
        this.documentationUploadService.postAuthByNumSol(this.numOperation).subscribe(
          (permission: any) => {
            if (!permission) {
              this.showDialogError();
            }
          },
          (error) => {
            this.showDialogError();
          }
        );
      }
    });

    this.filesToSendEnd = {
      files: [],
      numOperation: this.numOperation,
      version: '1',
      commercialProduct: this.commercialProduct,
      documentId: this.documentIdNumRequestDTO?.documentId,
    };
  }

  showDialogError() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Acceso denegado',
      text: 'No tienes permisos para acceder a esta operación',
      icon: 'icon-ic_circle_cross',
      buttonCancel: false,
      noRedirect: true,
    };
    const dialogPermission = this.dialog.open(ResponseDialogComponent, dialogConfig);

    dialogPermission.afterClosed().subscribe((_accept: boolean) => {
      this.router.navigate(['/home']);
    });
  }

  ngOnDestroy(): void {
    this.updateDocumentationStore.clearDocumentIdNumRequestHistory();
  }

  public goToPanel() {
    if (this.uploadMail) {
      this.router.navigate([HOME], { replaceUrl: true });
      this.uploadMail = false;
    } else if (this.goBack) {
      const mode =
        this.panelStore.getOperationToShow().status === REQUEST_PENDING ? REQUEST_MODE_EDIT : REQUEST_MODE_VIEW;
      this.router.navigate(['/requests/request-show-edit', mode, { tab: 'documentation' }]);
    } else {
      let pageOpenSignature = JSON.parse(localStorage.getItem('pageOpenSignature'));
      this.router.navigate([pageOpenSignature.url, { keepFilter: true }]);
    }
  }

  setFilesToUpload(f: any[]) {
    this.files = f;
    if (this.files.length > 0) {
      this.disableBtnUpload = false;
    }
  }

  sendUploadFiles() {
    let cont = 0;
    const numFiles = this.files.length;
    this.files.forEach((element) => {
      this.getBase64(element).then((fileBase64: string) => {
        if (fileBase64) {
          cont++;
          let fileToSend: AttachDocumentsDTO = {
            fileName: element.name,
            description: element.description,
            base64: fileBase64,
            type: element.type?.split('/')[1],
            extension: element.name?.split('.').pop(),
          };

          this.filesToSendEnd.files.push(fileToSend);

          if (cont === this.files.length) {
            this.documentationUploadService.postSendDocs(this.filesToSendEnd).subscribe(
              (resp: any) => {
                this.files = [];
                const dialogConfig = new MatDialogConfig();
                dialogConfig.data = {
                  title: this.translate.instant('uploadDocuments.correcltyUploaded'),
                  text: this.translate.instant('uploadDocuments.received', { numberOfFiles: numFiles }),
                  icon: 'icon-ic_circle_check',
                  noRedirect: true,
                };
                const dialog = this.dialog.open(ResponseDialogComponent, dialogConfig);
                dialog.afterClosed().subscribe(() => this.goToPanel());
                this.disableBtnUpload = true;
              },
              (error) => {
                const dialogConfig = new MatDialogConfig();
                dialogConfig.data = {
                  title: this.translate.instant('uploadDocuments.error'),
                  text: this.translate.instant('uploadDocuments.errorWhileUploading'),
                  icon: 'icon-ic_circle_cross',
                  noRedirect: true,
                };
                const dialog = this.dialog.open(ResponseDialogComponent, dialogConfig);
                dialog.afterClosed().subscribe(() => this.goToPanel());
              }
            );
          }
        }
      });
    });
  }

  private getBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result?.toString().split(',')[1]);
      reader.onerror = (error) => reject(error);
    });
  }

  private isDuplicateFile() {
    let valueArr = this.selectedFiles.map(function (item) {
      if (item !== null && item.file !== undefined) {
        return item?.file.name;
      }
    });
    valueArr = valueArr.filter(function (element) {
      return element !== undefined;
    });
    let isDuplicate = valueArr.some(function (item, idx) {
      return valueArr.indexOf(item) != idx;
    });

    return isDuplicate;
  }
}
